module.exports = __webpack_public_path__ + "static/media/Moto.19a9a8e7.svg";